import React, {Component} from 'react'

import withData from '../../utils/withData';
import {withSite} from '../../utils/Site';

class SetTemplate extends Component {

	constructor(props)
	{
		super(props)
		this.state = {
			template: ''
		}
	}

	componentWillReceiveProps(nextProps)
	{
		if(nextProps.template != this.state.template)
		{
			this.props.site.deModify(this.state.template)
			this.props.site.modify(nextProps.template)
			this.setState({template: nextProps.template})

		}
		
	}

  render () {

    const {
      template
    } = this.props



    return (
    	<div>
      {this.props.children}
      	</div>
    )
  }
}

export default withSite(withData(SetTemplate))



// WEBPACK FOOTER //
// ./src/js/components/SetTemplate/SetTemplate.jsx